<template>
  <div v-if="images && images.length" class="image-gallery" :class="{ 'image-gallery--nav': showNav }">
    <tiny-slider
      class="image-gallery__images" 
      v-bind="imageSliderOptions"
    >
      <video
        v-if="videoPath"
        class="image-gallery__video image-gallery__video--contain"
        :src="`${$store.state.assetsPath + videoPath}`"
        autoplay
        muted
        loop 
      ></video>
      <img 
        v-else
        v-for="image in images" 
        class="image-gallery__image" 
        :class="{ 'image-gallery__image--contain': containImages }"
        :src="$store.state.assetsPath + image" 
        :key="image"
      />
    </tiny-slider>
    <div v-show="showNav" class="image-gallery__thumbnails">
      <div class="image-gallery__thumbnail" v-for="image in images" :key="image">
        <img :src="$store.state.assetsPath + image">
        <div class="image-gallery__thumbnail-overlay"></div>
      </div>
    </div>
  </div>
</template>
<script>
import TinySlider from 'vue-tiny-slider'
export default {
  components: { TinySlider },
  props: [ 'contain-images', 'images', 'autoplay', 'show-nav' ],
  data () {
    return {
      imageSliderOptions: {
        mode: "gallery",
        autoplay: this.autoplay,
        autoplayTimeout: 4500,
        autoplayButton: false,
        autoplayButtonOutput: false,
        mouseDrag: false,
        controls: false,
        loop: true,
        items: 1,
        gutter: 0,
        nav: true,
        navContainer: '.image-gallery__thumbnails',
        navAsThumbnails: true,
        speed: 3000,
        animateIn: 'background--show',
        animateOut: 'background--hide',        
      },
    }
  },

  computed: {
    videoPath () {
      let videoPath = null
      this.images.forEach(path => {
        const type = path.split('.').pop()
        if (type === 'mp4') {
          videoPath = path
        }
      })

      return videoPath
    }
  }
}
</script>
<style lang="scss">
@import "@/styles/_variables.scss";
.image-gallery {
  left: 0;
  height: 100%;
  position: absolute;
  top: 0;
  width: 100%;

    &--nav {
      padding-bottom: 14rem;
    }  

  .tns-outer, .tns-inner {
    height: 100%;
  }

  &__images {
    height: 100%;
    width: 100%;
  }

  &__image {
    height: 100%;
    width: 100%;
    object-fit: cover;

    &--contain {
      object-fit: contain;
    }
  }

  &__video {
    height: 100rem;
    width: 100%;
    object-fit: cover;

    &--contain {
      object-fit: contain;
    }
  }

  &__thumbnails {
    background: rgba($gold, 0.9);
    position: absolute;
    bottom: 0;
    width: 100%;
    text-align: center;
    height: 14rem;

    .tns-nav-active {
      border: 1px solid white;

      .image-gallery__thumbnail-overlay {
        background-color: rgba($gold, 0);
      }
    }
  }

  &__thumbnail {
    display: inline-block;
    border: 1px solid rgba(255,255,255,0.7);
    height: 10rem;
    width: 10rem;
    margin: 2rem 1rem;
    position: relative;

    img {
      height: 100%;
      width: 100%;
      object-fit: cover;
    }
  }

  &__thumbnail-overlay {
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;
    background-color: rgba($gold, 0.4);
    transition: background-color 0.3s;
  }
}
</style>